import { createNavigation } from 'next-intl/navigation';
import { SUPPORTED_LOCALES } from '@/intlconf';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: SUPPORTED_LOCALES,
    defaultLocale: 'en',
    localePrefix: 'always',

    // it's needed to declare the routes here to make usePathname work correctly:
    // https://next-intl.dev/docs/routing/navigation#usepathname
    pathnames: {
        '/': '/',

        '/auth/create-password': '/auth/create-password',
        '/auth/forgot-password': '/auth/forgot-password',
        '/auth/login': '/auth/login',
        '/auth/signup': '/auth/signup',
        '/auth/reset-password': '/auth/reset-password',

        '/account-setup': '/account-setup',

        '/[farmId]/clients': '/[farmId]/clients',
        '/[farmId]/bills': '/[farmId]/bills',
        '/[farmId]/devices': '/[farmId]/devices',
        '/[farmId]/logs': '/[farmId]/logs',
        '/[farmId]/assets': '[farmId]/assets',
        '/[farmId]/typed-tasks': '/[farmId]/typed-tasks',
        '/[farmId]/typed-tasks/[taskTypeId]': '/[farmId]/typed-tasks/[taskTypeId]',
        '/[farmId]/basic-tasks': '/[farmId]/basic-tasks',
        '/[farmId]/maintenance-tasks': '/[farmId]/maintenance-tasks',

        '/admin/settings/firmwares': '/admin/settings/firmwares',

        '/admin/settings/pricing-plans': '/admin/settings/pricing-plans',
        '/admin/settings/pricing-plans/add': '/admin/settings/pricing-plans/add',
        '/admin/settings/pricing-plans/edit/[id]': '/admin/settings/pricing-plans/edit/[id]',
        '/admin/settings/invoices': '/admin/settings/invoices',
        '/admin/settings/notifications': '/admin/settings/notifications',
        '/admin/settings/invoices/add': '/admin/settings/invoices/add',
        '/admin/settings/invoices/edit/[id]': '/admin/settings/invoices/edit/[id]',
        '/admin/settings/customers': '/admin/settings/customers',
        '/admin/settings/customers/add': '/admin/settings/customers/add',
        '/admin/settings/customers/edit/[id]': '/admin/settings/customers/edit/[id]',

        '/devices': '/devices',
        '/scanning': '/scanning',
        '/tasks': '/tasks',
        '/maintenance-tasks': '/maintenance-tasks',
        '/welcome': '/welcome',

        '/invoices': '/invoices',
        '/tariffs': '/tariffs',

        '/settings/automation': '/settings/automation',
        '/settings/billing': '/settings/billing',
        '/settings/facilities': '/settings/facilities',
        '/settings/facilities/add': '/settings/facilities/add',
        '/settings/facilities/edit/[id]': '/settings/facilities/edit/[id]',
        '/settings/profile': '/settings/profile',
        '/settings/roles': '/settings/roles',
        '/settings/roles/add': '/settings/roles/add',
        '/settings/roles/edit/[id]': '/settings/roles/edit/[id]',
        '/settings/staff': '/settings/staff',
        '/settings/staff/add': '/settings/staff/add',
        '/settings/staff/[edit]': '/settings/staff/[edit]',
        '/settings/tasks': '/settings/tasks',
        '/settings/topology': '/settings/topology',
        '/settings/topology/edit/[farmId]': '/settings/topology/edit/[farmId]',
        '/settings/topology/view/[farmId]': '/settings/topology/view/[farmId]',
        '/settings/admin-logs': '/settings/admin-logs',
        '/settings/quickstart': '/settings/quickstart',
        '/settings/workflows': '/settings/workflows',
        '/settings/workflows/add': '/settings/workflows/add',
        '/settings/workflows/edit/[id]': '/settings/workflows/edit/[id]',
        '/settings/workflows/build/[id]': '/settings/workflows/build/[id]',
        '/settings/custom-fields': '/settings/custom-fields',
        '/settings/custom-fields/add': '/settings/custom-fields/add',
        '/settings/custom-fields/edit/[id]': '/settings/custom-fields/edit/[id]',
        '/settings/assets/consumables-types': '/settings/assets/consumables-types',
        '/settings/assets/consumables-types/add': '/settings/assets/consumables-types/add',
        '/settings/assets/consumables-types/edit/[id]': '/settings/assets/consumables-types/edit/[id]',
        '/settings/assets/consumables': '/settings/assets/consumables',
        '/settings/assets/consumables/add': '/settings/assets/consumables/add',
        '/settings/assets/consumables/edit/[id]': '/settings/assets/consumables/edit/[id]',
        '/settings/assets/items-sub-categories': '/settings/assets/items-sub-categories',
        '/settings/assets/items-sub-categories/add': '/settings/assets/items-sub-categories/add',
        '/settings/assets/items-sub-categories/edit/[id]': '/settings/assets/items-sub-categories/edit/[id]',
        '/settings/assets/items-categories': '/settings/assets/items-categories',
        '/settings/assets/items-categories/add': '/settings/assets/items-categories/add',
        '/settings/assets/items-categories/edit/[id]': '/settings/assets/items-categories/edit/[id]',
        '/settings/assets/items': '/settings/assets/items',
        '/settings/assets/items/add': '/settings/assets/items/add',
        '/settings/assets/items/edit/[id]': '/settings/assets/items/edit/[id]',
        '/settings/assets/vendors': '/settings/assets/vendors',
        '/settings/assets/vendors/add': '/settings/assets/vendors/add',
        '/settings/assets/vendors/edit/[id]': '/settings/assets/vendors/edit/[id]',
        '/settings/assets/suppliers': '/settings/assets/suppliers',
        '/settings/assets/suppliers/add': '/settings/assets/suppliers/add',
        '/settings/assets/suppliers/edit/[id]': '/settings/assets/suppliers/edit/[id]',
        '/settings/assets/custom-fields': '/settings/assets/custom-fields',
        '/settings/assets/custom-fields/add': '/settings/assets/custom-fields/add',
        '/settings/assets/custom-fields/edit/[id]': '/settings/assets/custom-fields/edit/[id]',
        '/settings/task-types': '/settings/task-types',
        '/settings/task-types/add': '/settings/task-types/add',
        '/settings/task-types/edit/[id]': '/settings/task-types/edit/[id]',
        '/settings/notifications': '/settings/notifications',

        '/settings/watchers': '/settings/watchers',
        '/settings/watchers/add': '/settings/watchers/add',
        '/settings/watchers-settings': '/settings/watchers-settings',

        '/settings/tax/details': '/settings/tax/details',
        '/settings/tax/details/add': '/settings/tax/details/add',
        '/settings/tax/details/edit/[id]': '/settings/tax/details/edit/[id]',
        '/settings/tax/reports': '/settings/tax/reports',
        '/settings/tax/reports/add': '/settings/tax/reports/add',
        '/settings/tax/reports/edit/[id]': '/settings/tax/reports/edit/[id]',

        '/watcher/[token]': '/watcher/[token]',

        '/dashboard': '/dashboard'
    }
});

//Redirect in server side component must be handled without try catch
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);

export const getLocalizedLink = (locale: string, href: string) => {
    return `/${locale}${href}`;
};

const pathNamePageNameMap = {
    '/auth/create-password': 'Create password',
    '/auth/forgot-password': 'Forgot password',
    '/auth/login': 'Login',
    '/auth/register': 'Register',
    '/auth/reset-password': 'Reset password',

    '/[farmId]/clients': 'Farm client',
    '/[farmId]/bills': 'Farm bills',
    '/[farmId]/devices': 'Dashboard',
    '/[farmId]/logs': 'Farm logs',
    '/[farmId]/tasks': 'Farm tasks',
    '/[farmId]/maintenance-tasks': 'Farm tasks',

    '/admin/settings/firmwares': 'Firmwares',
    '/devices': 'Devices (redirect page)',
    '/scanning': 'Scanning',
    '/tasks': 'Tasks (redirect page)',
    '/welcome': 'Welcome',

    '/settings/automation': 'Automation',
    '/settings/billing': 'Billing',
    '/settings/facilities': 'Facilities',
    '/settings/facilities/add': 'Add facility',
    '/settings/facilities/edit/[id]': 'Edit facility',
    '/settings/profile': 'Profile',
    '/settings/roles': 'Roles',
    '/settings/roles/add': 'Add role',
    '/settings/roles/edit/[id]': 'Edit role',
    '/settings/staff': 'Staff',
    '/settings/staff/add': 'Add staff',
    '/settings/staff/[edit]': 'Edit staff',
    '/settings/tasks': 'Tasks',
    '/settings/topology': 'Topology',
    '/settings/topology/edit/[farmId]': 'Edit topology',
    '/settings/topology/view/[farmId]': 'View topology',
    '/settings/admin-logs': 'Admin logs',
    '/settings/quickstart': 'Quickstart',
    '/settings/watchers': 'Watchers',
    '/settings/notifications': 'Notifications',

    '/watcher/[token]': 'Watcher',
    '/dashboard': 'Inactive user'
};

export const pathNameToPageName = (pathname: string): string => {
    return pathNamePageNameMap?.[pathname] || 'Unknown page';
};
